/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookedService
 */
export interface BookedService {
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    showId?: number;
    /**
     * 
     * @type {string}
     * @memberof BookedService
     */
    bookerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookedService
     */
    riderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookedService
     */
    horseId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    serviceId?: number;
    /**
     * 
     * @type {Date}
     * @memberof BookedService
     */
    bookingDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    totalPrice?: number;
    /**
     * 
     * @type {Date}
     * @memberof BookedService
     */
    cancelDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BookedService
     */
    cancellableUntil?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof BookedService
     */
    accountedRef?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BookedService
     */
    starterId?: number;
}

/**
 * Check if a given object implements the BookedService interface.
 */
export function instanceOfBookedService(value: object): value is BookedService {
    return true;
}

export function BookedServiceFromJSON(json: any): BookedService {
    return BookedServiceFromJSONTyped(json, false);
}

export function BookedServiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookedService {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'showId': json['showId'] == null ? undefined : json['showId'],
        'bookerId': json['bookerId'] == null ? undefined : json['bookerId'],
        'riderId': json['riderId'] == null ? undefined : json['riderId'],
        'horseId': json['horseId'] == null ? undefined : json['horseId'],
        'serviceId': json['serviceId'] == null ? undefined : json['serviceId'],
        'bookingDate': json['bookingDate'] == null ? undefined : (new Date(json['bookingDate'])),
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'cancelDate': json['cancelDate'] == null ? undefined : (new Date(json['cancelDate'])),
        'cancellableUntil': json['cancellableUntil'] == null ? undefined : (new Date(json['cancellableUntil'])),
        'accountedRef': json['accountedRef'] == null ? undefined : json['accountedRef'],
        'starterId': json['starterId'] == null ? undefined : json['starterId'],
    };
}

export function BookedServiceToJSON(json: any): BookedService {
    return BookedServiceToJSONTyped(json, false);
}

export function BookedServiceToJSONTyped(value?: BookedService | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'showId': value['showId'],
        'bookerId': value['bookerId'],
        'riderId': value['riderId'],
        'horseId': value['horseId'],
        'serviceId': value['serviceId'],
        'bookingDate': value['bookingDate'] == null ? undefined : ((value['bookingDate']).toISOString()),
        'quantity': value['quantity'],
        'totalPrice': value['totalPrice'],
        'cancelDate': value['cancelDate'] == null ? undefined : ((value['cancelDate'] as any).toISOString()),
        'cancellableUntil': value['cancellableUntil'] == null ? undefined : ((value['cancellableUntil'] as any).toISOString()),
        'accountedRef': value['accountedRef'],
        'starterId': value['starterId'],
    };
}

